<template>
  <div>
    <div
      class="ml-4 mr-4"
      :style="pathMixin_isMeeting ? 'max-width: 800px !important;' : ''"
    >
      <div class="is-flex is-justify-content-center filtersContainer">
        <!--  ALL FILTERS MODAL BOX -->
        <div ref="mainFilterButton" id="mainFilterButton">
          <ShowModalButton
            :rounded="true"
            :label="filterButtonLabel"
            :type="'is-info is-outlined'"
            :size="'is-small'"
            :icon-left="'filter-variant-plus'"
            :close-modal="closeCustomModal"
            :key="forceKey"
            data-test="modal_filters_button"
          >
            <template #modalContent>
              <div id="modalFilters">
                <h2 class="is-size-4 gant-text has-text-centered">
                  {{ filterButtonLabel }}
                </h2>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                    "
                  />
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                      forceClose_closeModal();
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
                <hr class="mt-1 mb-5" />
                <div class="is-flex is-justify-content-center mb-2">
                  <div ref="unusedTicketsOnly">
                    <b-button
                      v-if="unusedTickets.length > 0"
                      rounded
                      :type="value.unusedTicketsOnly ? 'is-info' : 'is-default'"
                      size="is-small"
                      :icon-left="
                        value.unusedTicketsOnly ? 'checkbox-marked-outline' : ''
                      "
                      @click="toggleShowUnusedTicketsOnly()"
                    >
                      Show Unused Tickets Only
                      <ResetFilterButton
                        v-if="value.unusedTicketsOnly"
                        @reset="resetFilter('unusedTicketsOnly')"
                      />
                    </b-button>
                  </div>
                </div>

                <div class="columns" style="padding: 3%">
                  <!-- SORT BY -->
                  <div v-if="sortOptions.length > 0" class="column is-flex">
                    <FieldsetBox
                      :box-style="value.sortOrder ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.sortOrder
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Sort by</span
                        >
                      </template>
                      <template #content>
                        <SortButtons
                          v-model="value.sortOrder"
                          :options="sortOptions"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- AIRLINES -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="
                        value.selectedAirlines.length > 0
                          ? highlightedBoxStyle
                          : ''
                      "
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.selectedAirlines.length > 0
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Airlines</span
                        >
                      </template>
                      <template #content>
                        <ChainSelection
                          data-test="modal_airlines_filter_list"
                          :selectedChains="value.selectedAirlines"
                          :preferredVendors="preferredVendors"
                          :preferredOnly.sync="preferredOnly"
                          :availableChains="filterOptions.allAirlines"
                          :filteredChains="filterOptions.filteredAirlines"
                          @input="handleChainInput"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- RATING -->
                  <div
                    v-if="filterOptions.highestRating"
                    class="column is-flex"
                  >
                    <FieldsetBox
                      :box-style="value.minRating ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.minRating
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Rating</span
                        >
                      </template>
                      <template #content>
                        <RatingSelectionRadioButtons
                          v-model="value.minRating"
                          :highestRating="filterOptions.highestRating"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- PRICE -->
                  <div v-if="filterOptions.priceData" class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.price ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.price
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Price</span
                        >
                      </template>
                      <template #content>
                        <b-field
                          :label="
                            'Price: $' +
                              filterOptions.priceData[0] +
                              '-$' +
                              filterOptions.priceData[
                                filterOptions.priceData.length - 1
                              ]
                          "
                          style="width: 180px"
                        >
                          <HistogramSliderW2
                            :value="priceRange"
                            :width="180"
                            :expo="true"
                            :height="25"
                            :sliderData="filterOptions.priceData"
                            @change="priceFilterUpdate"
                          ></HistogramSliderW2>
                        </b-field>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>
                <div class="columns" style="padding: 3%">
                  <!-- POLICY -->
                  <div
                    v-if="filterOptions.availablePolicies"
                    class="column is-flex is-one-quarter"
                  >
                    <FieldsetBox
                      :box-style="value.minPolicy ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.minPolicy
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Policy</span
                        >
                      </template>
                      <template #content>
                        <PolicySelectionCheckboxes
                          v-model="value.minPolicy"
                          :availablePolicies="filterOptions.availablePolicies"
                        ></PolicySelectionCheckboxes>
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- STOPS -->
                  <div v-if="showStops" class="column is-flex is-one-third">
                    <FieldsetBox
                      :box-style="highlights.stops ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.stops
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Stops</span
                        >
                      </template>
                      <template #content>
                        <div class="filterFlexContainer">
                          <div v-if="filterOptions.stops.length > 0">
                            <h5 class="is-size-7 is-uppercase">
                              <strong
                                >{{ filterOptions.stops[0].name }}
                              </strong>
                            </h5>
                            <div class="field">
                              <FlightStopsSelectionRadioBoxes
                                data-test="modal_outbound_stops_filter_list"
                                :options="filterOptions.stops[0].options"
                                v-model="value.maxStopsSegment1"
                              ></FlightStopsSelectionRadioBoxes>
                            </div>
                          </div>
                          <div v-if="filterOptions.stops.length > 1" class="">
                            <h5 class="is-size-7 is-uppercase">
                              <strong
                                >{{ filterOptions.stops[1].name }}
                              </strong>
                            </h5>
                            <div class="field">
                              <FlightStopsSelectionRadioBoxes
                                data-test="modal_return_stops_filter_list"
                                :options="filterOptions.stops[1].options"
                                v-model="value.maxStopsSegment2"
                              ></FlightStopsSelectionRadioBoxes>
                            </div>
                          </div>
                        </div>
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- TIMES -->
                  <div v-if="showTimes" class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.times ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.times
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Times</span
                        >
                      </template>
                      <template #content>
                        <div class="filterFlexContainer">
                          <div>
                            <div class="">
                              <h5 class="is-size-7 is-uppercase">
                                <strong>Outbound Flight</strong>
                              </h5>
                              <div class="field">
                                <FlightTimeSelection
                                  v-model="value.timeRangeSegment1"
                                />
                              </div>
                            </div>
                          </div>
                          <div v-if="filterOptions.times.length > 1">
                            <div class="">
                              <h5 class="is-size-7 is-uppercase">
                                <strong>Return Flight</strong>
                              </h5>
                              <div class="field">
                                <FlightTimeSelection
                                  v-model="value.timeRangeSegment2"
                                ></FlightTimeSelection>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>
                <div class="columns" style="padding: 3%">
                  <!-- NDC Filters-->
                  <div
                  v-if="filterOptions.ndc"
                    class="column is-flex is-one-quarter"
                  >
                    <FieldsetBox
                      :box-style="value.ndc ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            value.ndc
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >NDC Options</span
                        >
                      </template>
                      <template #content>
                        <b-radio
                        v-model="value.ndc"
                        name="ndc"
                        type="is-teal"
                        size="is-small"
                        native-value="NDC Only"
                        @click.native="value.ndc = 'NDC Only'"
                      >
                        NDC Only </b-radio
                      ><br />
                      <b-radio
                        v-model="value.ndc"
                        name="ndc"
                        type="is-teal"
                        size="is-small"
                        native-value="Exclude NDC"
                        @click.native="value.ndc = 'Exclude NDC'"
                      >
                        Exclude NDC </b-radio
                      ><br />
                      <b-radio
                        v-model="value.ndc"
                        name="ndc"
                        type="is-teal"
                        size="is-small"
                        native-value="All"
                        @click.native="value.ndc = 'All'"
                      >
                        All
                      </b-radio>
                      </template>
                    </FieldsetBox>
                  </div>

                </div>

                <div class="is-flex is-justify-content-center pt-5">
                  <b-button
                    type="is-primary"
                    size="is-small"
                    label="Apply Filters"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                  <b-button
                    type="is-outlined"
                    size="is-small"
                    label="Close"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                </div>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                    "
                  />
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox();
                      $emit('clearFilters');
                      forceClose_closeModal();
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
              </div>
            </template>
          </ShowModalButton>
        </div>

        <!--  THE REST of the FILTERS (Custom Dropdowns) -->
        <div
          class="flexedFilters sortingFiltersContainer scrollContent is-flex"
        >
          <!-- UNUSED TICKETS -->
          <div v-if="unusedTickets" ref="unusedTicketsOnly">
            <b-button
              v-if="unusedTickets.length > 0"
              rounded
              :type="value.unusedTicketsOnly ? 'is-info' : 'is-default'"
              size="is-small"
              :icon-left="
                value.unusedTicketsOnly ? 'checkbox-marked-outline' : ''
              "
              @click="toggleShowUnusedTicketsOnly()"
            >
              Show Unused Tickets Only
              <ResetFilterButton
                v-if="value.unusedTicketsOnly"
                @reset="resetFilter('unusedTicketsOnly')"
              />
            </b-button>
          </div>
          <!-- SORT BY -->
          <section v-if="sortOptions.length > 0">
            <div ref="sortOrder">
              <b-button
                data-test="sort_filter_button"
                rounded
                size="is-small"
                :icon-right="!value.sortOrder ? 'menu-down' : null"
                :type="value.sortOrder ? 'is-info is-light' : 'is-outlined'"
                @click="
                  $popper.togglePopper($refs.sortOrder, $refs.sortButtons)
                "
              >
                Sort by{{ value.sortOrder ? ":" : "" }}
                <span class="has-text-weight-bold">{{
                  getSortLabel(value.sortOrder)
                }}</span>
              </b-button>
            </div>
            <div ref="sortButtons" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Sort by"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <SortButtons
                data-test="sort_filter_list"
                v-model="value.sortOrder"
                :options="sortOptions"
              />
            </div>
          </section>
          <!-- AIRLINES -->
          <section v-if="filterOptions.allAirlines">
            <div ref="selectedAirlines">
              <b-button
                data-test="airlines_filter_button"
                rounded
                size="is-small"
                :icon-right="
                  !value.selectedAirlines.length > 0 ? 'menu-down' : null
                "
                :type="
                  value.selectedAirlines.length > 0
                    ? 'is-info is-light'
                    : 'is-outlined'
                "
                @click="
                  $popper.togglePopper(
                    $refs.selectedAirlines,
                    $refs.airlinesCBs
                  )
                "
              >
                <span v-if="value.selectedAirlines.length > 0">
                  Airlines:
                  <span class="has-text-weight-bold">
                    {{
                      value.selectedAirlines
                        .map((airline) => $helpers.airlineName(airline.code))
                        .join(", ")
                    }}
                  </span>
                </span>
                <span v-else>Airlines</span>
                <ResetFilterButton
                  v-if="value.selectedAirlines.length > 0"
                  @reset="resetFilter('selectedAirlines')"
                />
              </b-button>
            </div>
            <div ref="airlinesCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Airlines"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <ChainSelection
                data-test="airlines_filter_list"
                :selectedChains="value.selectedAirlines"
                :availableChains="filterOptions.allAirlines"
                :filteredChains="filterOptions.filteredAirlines"
                :preferredVendors="preferredVendors"
                :preferredOnly.sync="preferredOnly"
                @input="handleChainInput"
              />
            </div>
          </section>
          <!-- POLICY -->
          <section v-if="filterOptions.availablePolicies">
            <div ref="minPolicy">
              <b-button
                data-test="policy_filter_button"
                rounded
                size="is-small"
                :icon-right="!value.minPolicy ? 'menu-down' : null"
                :type="value.minPolicy ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.minPolicy, $refs.policyCBs)"
              >
                Policy{{ value.minPolicy ? ":" : "" }}
                <span class="has-text-weight-bold">{{
                  returnPolicyValues(value.minPolicy)
                }}</span>
                <ResetFilterButton
                  v-if="value.minPolicy"
                  @reset="resetFilter('minPolicy')"
                />
              </b-button>
            </div>
            <div ref="policyCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Min Policy"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <PolicySelectionCheckboxes
                v-model="value.minPolicy"
                :availablePolicies="filterOptions.availablePolicies"
              />
            </div>
          </section>
          <!-- RATING -->
          <section v-if="filterOptions.highestRating">
            <div ref="minRating">
              <b-button
                data-test="rating_filter_button"
                rounded
                size="is-small"
                :icon-right="!value.minRating ? 'menu-down' : null"
                :type="value.minRating ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.minRating, $refs.ratingCBs)"
              >
                Rating{{ value.minRating ? ":" : "" }}
                <span class="has-text-weight-bold" v-if="value.minRating">{{
                  ratingLabel(value.minRating)
                }}</span>
                <ResetFilterButton
                  v-if="value.minRating"
                  @reset="resetFilter('minRating')"
                />
              </b-button>
            </div>
            <div ref="ratingCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Min Rating"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <RatingSelectionRadioButtons
                v-model="value.minRating"
                :highestRating="filterOptions.highestRating"
              />
            </div>
          </section>
          <!-- PRICE -->
          <section v-if="filterOptions.priceData">
            <div ref="maxPrice">
              <b-button
                data-test="price_filter_button"
                rounded
                size="is-small"
                :icon-right="!highlights.price ? 'menu-down' : null"
                :type="highlights.price ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.maxPrice, $refs.priceCBs)"
              >
                Price{{ highlights.price ? ":" : "" }}
                <span class="has-text-weight-bold" v-if="highlights.price">{{
                  `$${value.minPrice} - $${value.maxPrice}`
                }}</span>
                <ResetFilterButton
                  v-if="highlights.price"
                  @reset="resetFilter('priceRange')"
                />
              </b-button>
            </div>
            <div ref="priceCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Price Range"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="ml-3 mr-3">
                <b-field
                  :label="
                    'Price: $' +
                      filterOptions.priceData[0] +
                      '-$' +
                      filterOptions.priceData[
                        filterOptions.priceData.length - 1
                      ]
                  "
                  style="width: 180px"
                >
                </b-field>
                <HistogramSliderW2
                  :value="priceRange"
                  :width="180"
                  :expo="true"
                  :height="25"
                  :sliderData="filterOptions.priceData"
                  @input="priceFilterUpdate"
                  :key="forceKey"
                ></HistogramSliderW2>
              </div>
            </div>
          </section>
          <!-- STOPS -->
          <section v-if="showStops">
            <div ref="flightStops">
              <b-button
                data-test="stops_filter_button"
                rounded
                size="is-small"
                :icon-right="!highlights.stops ? 'menu-down' : null"
                :type="highlights.stops ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.flightStops, $refs.stopsCBs)"
              >
                Stops{{ highlights.stops ? ":" : "" }}

                <span class="has-text-weight-bold" v-if="highlights.stops">
                  {{
                    stopsLabel(value.maxStopsSegment1, value.maxStopsSegment2)
                  }}
                </span>
                <ResetFilterButton
                  v-if="highlights.stops"
                  @reset="
                    resetFilter('maxStopsSegment1');
                    resetFilter('maxStopsSegment2');
                  "
                />
              </b-button>
            </div>
            <div ref="stopsCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Stops"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="filterFlexContainer">
                <div>
                  <h5 class="is-size-7 is-uppercase">
                    <strong>{{ filterOptions.stops[0].name }}</strong>
                  </h5>
                  <div class="field">
                    <FlightStopsSelectionRadioBoxes
                      data-test="outbound_stops_filter_list"
                      :options="filterOptions.stops[0].options"
                      v-model="value.maxStopsSegment1"
                    ></FlightStopsSelectionRadioBoxes>
                  </div>
                </div>
                <div v-if="filterOptions.stops.length > 1" class="">
                  <h5 class="is-size-7 is-uppercase">
                    <strong> {{ filterOptions.stops[1].name }} </strong>
                  </h5>
                  <div class="field">
                    <FlightStopsSelectionRadioBoxes
                      data-test="return_stops_filter_list"
                      :options="filterOptions.stops[1].options"
                      v-model="value.maxStopsSegment2"
                    ></FlightStopsSelectionRadioBoxes>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- TIMES -->
          <section v-if="showTimes">
            <div ref="flightTimes">
              <b-button
                rounded
                size="is-small"
                :icon-right="!highlights.times ? 'menu-down' : null"
                :type="highlights.times ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.flightTimes, $refs.timesCBs)"
              >
                <span v-if="!highlights.times">Times</span>
                <span v-else>
                  Times:
                  <span class="has-text-weight-bold">
                    {{
                      returnFlightTimesValues(
                        value.timeRangeSegment1,
                        value.timeRangeSegment2
                      )
                    }}
                  </span>
                </span>
                <ResetFilterButton
                  v-if="highlights.times"
                  @reset="
                    resetFilter('timeRangeSegment1');
                    resetFilter('timeRangeSegment2');
                  "
                />
              </b-button>
            </div>
            <div ref="timesCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Times"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="filterFlexContainer">
                <div>
                  <div class="">
                    <h5 class="is-size-7 is-uppercase">
                      <strong>Outbound</strong>
                    </h5>
                    <div class="field">
                      <FlightTimeSelection
                        v-model="value.timeRangeSegment1"
                      ></FlightTimeSelection>
                    </div>
                  </div>
                </div>
                <div v-if="filterOptions.times.length > 1">
                  <div class="">
                    <h5 class="is-size-7 is-uppercase">
                      <strong>Return</strong>
                    </h5>
                    <div class="field">
                      <FlightTimeSelection
                        v-model="value.timeRangeSegment2"
                      ></FlightTimeSelection>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div v-if="filterOptions.ndc" ref="ndcFilterButton">
              <b-button
                rounded
                size="is-small"
                data-test="ndc_filter_button"
                :icon-right="!highlights.ndc ? 'menu-down' : ''"
                :type="highlights.ndc ? 'is-info is-light' : 'is-outlined'"
                @click="
                  $popper.togglePopper(
                    $refs.ndcFilterButton,
                    $refs.ndcDropdownMenu
                  )
                "
              >
                <span v-if="!highlights.ndc">
                  NDC
                </span>
                <span v-else>
                  NDC: <span class="has-text-weight-bold">{{ value.ndc }}</span>
                </span>
                <ResetFilterButton
                  v-if="highlights.ndc"
                  @reset="resetFilter('ndc')"
                />
              </b-button>
            </div>
            <div ref="ndcDropdownMenu" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="ndc"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <b-radio
                v-model="value.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="NDC Only"
                @click.native="value.ndc = 'NDC Only'"
              >
                NDC Only </b-radio
              ><br />
              <b-radio
                v-model="value.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="Exclude NDC"
                @click.native="value.ndc = 'Exclude NDC'"
              >
                Exclude NDC </b-radio
              ><br />
              <b-radio
                v-model="value.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="All"
                @click.native="value.ndc = 'All'"
              >
                All
              </b-radio>
            </div>
          </section>
        </div>
      </div>
    </div>
    <ResetAllFiltersButton
      v-if="numOfFiltersUsed > 2"
      @clicked="
        forceClose_closeDropdownBox();
        $emit('clearFilters');
      "
    />
  </div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin";

import ChainSelection from "./ChainSelection.vue";
import SortButtons from "./SortButtons.vue";
import PolicySelectionCheckboxes from "./PolicySelectionCheckboxes.vue";
import RatingSelectionRadioButtons from "./RatingSelectionRadioButtons";
import FlightStopsSelectionRadioBoxes from "./FlightStopsSelectionRadioBoxes.vue";
import FlightTimeSelection from "./FlightTimeSelection.vue";
import HistogramSliderW2 from "../HistogramSlider/HistogramSliderW2.vue";

import ShowModalButton from "../UI/ShowModalButton";
import ResetFilterButton from "./ResetFilterButton";
import FieldsetBox from "../UI/FieldsetBox";
import ResetAllFiltersButton from "./ResetAllFiltersButton";
import FilterBoxHeader from "./FilterBoxHeader";

export default {
  name: "FlightFilters",
  mixins: [bookingMixin],
  components: {
    ChainSelection,
    SortButtons,
    HistogramSliderW2,
    PolicySelectionCheckboxes,
    RatingSelectionRadioButtons,
    FlightStopsSelectionRadioBoxes,
    FlightTimeSelection,
    ShowModalButton,
    ResetFilterButton,
    FieldsetBox,
    ResetAllFiltersButton,
    FilterBoxHeader,
  },
  data() {
    return {
      showUnusedTicketsOnly: false,
      preferredOnly: false,
    };
  },
  props: {
    filterOptions: Object,
    sortOptions: Array,
    value: Object,
    unusedTickets: {},
    tripVal: {},
    highlights: Object,
    preferredVendors: Array,
  },
  computed: {
    priceRange() {
      return Array(this.value.minPrice, this.value.maxPrice);
    },
    numOfFiltersUsed() {
      let num = 0;
      for (let highlight in this.highlights) {
        if (this.highlights[highlight] === true) {
          num++;
        }
      }
      return num;
    },
    /*
    isStopsFilterUsed() {
      if (this.tripVal != 2) {
        return (
          this.value.maxStopsSegment1 !== "" ||
          this.value.maxStopsSegment2 !== ""
        );
      } else {
        return false;
      }
    },
    isTimesFilterUsed() {
      if (this.tripVal != 2) {
        if (this.tripVal > 0) {
          return (
            this.value.timeRangeSegment1.range[0] > 0 ||
            this.value.timeRangeSegment2.range[0] > 0 ||
            this.value.timeRangeSegment1.range[1] < 24 ||
            this.value.timeRangeSegment2.range[1] < 24
          );
        } else {
          return (
            this.value.timeRangeSegment1.range[0] > 0 ||
            this.value.timeRangeSegment1.range[1] < 24
          );
        }
      } else {
        return false;
      }
    },
    */
    showTimes() {
      return this.filterOptions?.times?.length > 0;
    },
    showStops() {
      return this.filterOptions?.stops?.length > 0;
    },
  },
  methods: {
    getSortLabel(val) {
      let option = this.sortOptions.find((option) => {
        return option.value == val;
      });

      if (option) {
        return option.label;
      } else {
        return val;
      }
    },

    handleChainInput(val) {
      this.value.selectedAirlines = val;
      this.$emit("input", this.value);
    },
    toggleShowUnusedTicketsOnly() {
      // console.log(`toggle unused tickets BEFORE: `, this.showUnusedTicketsOnly);
      this.showUnusedTicketsOnly = !this.showUnusedTicketsOnly;
      // console.log(`toggle unused tickets AFTER: `, this.showUnusedTicketsOnly);
      this.handleUnusedTicketsInput(this.showUnusedTicketsOnly);
    },
    handleUnusedTicketsInput(val) {
      this.value.unusedTicketsOnly = val;
      this.$emit("input", this.value);
      this.forceClose_closeDropdownBox();
    },
    priceFilterUpdate(val) {
      if (this.value.minPrice != val[0] || this.value.maxPrice != val[1]) {
        this.value.minPrice = val[0];
        this.value.maxPrice = val[1];
        this.$emit("input", this.value);
      }
    },
    /*
    handleSortInput(val) {
      this.value.sortOrder = val;
      // console.log(`handleSortInput(): ${val} ${JSON.stringify(this.value)}`);
      this.$emit("input", this.value);
    },
    handlePolicyInput(val) {
      this.value.minPolicy = val;
      this.$emit("input", this.value);
    },
    handleRatingInput(val) {
      this.value.minRating = val;
      this.$emit("input", this.value);
    },
    handleStops1Input(val) {
      this.value.maxStopsSegment1 = val;
      this.$emit("input", this.value);
    },
    handleStops2Input(val) {
      this.value.maxStopsSegment2 = val;
      this.$emit("input", this.value);
    },
    handleTime1Input(val) {
      this.value.timeRangeSegment1 = val;
      this.$emit("input", this.value);
    },
    handleTime2Input(val) {
      //console.log('handleTime2Input()');
      this.value.timeRangeSegment2 = val;
      this.$emit("input", this.value);
    },
    */

    resetFilter(filterType) {
      this.filterTypeToReset = filterType;
      this.$emit("resetFilter", this.filterTypeToReset);
      this.forceKey_forceKeyChange();
      if (filterType === "unusedTicketsOnly") {
        this.showUnusedTicketsOnly = false;
      }
      this.forceClose_closeDropdownBox();
    },
    ratingLabel(val) {
      let rating;

      switch (val) {
        case 50:
          rating = "5+";
          break;
        case 60:
          rating = "6+";
          break;
        case 70:
          rating = "7+";
          break;
        case 80:
          rating = "8+";
          break;
        case 90:
          rating = "9+";
          break;
        default:
          rating = "Any";
      }

      return rating;
    },
    stopsLabel(stop1, stop2) {
      let stop1Value;
      let stop2Value;

      switch (stop1) {
        case 0:
          stop1Value = "Non-stop";
          break;
        case 1:
          stop1Value = "1 stop or less";
          break;
        case 2:
          stop1Value = "2 stops or less";
          break;
        default:
        //
      }

      switch (stop2) {
        case 0:
          stop2Value = "Non-stop";
          break;
        case 1:
          stop2Value = "1 stop or less";
          break;
        case 2:
          stop2Value = "2 stops or less";
          break;
        default:
        //
      }

      let flightStops = "";
      stop1Value ? (flightStops += `Outbound: ${stop1Value}`) : "";
      stop1Value && stop2Value ? (flightStops += ` / `) : "";
      stop2Value ? (flightStops += `Return: ${stop2Value}`) : "";

      return flightStops;
    },
    returnFlightTimesValues(time1, time2) {
      let timesInfo = "";

      if (time1.range[0] > 0 || time1.range[1] < 24) {
        timesInfo += "OUTBOUND - ";
        if (time1.segment === 0) {
          timesInfo += "Departure: ";
        } else {
          timesInfo += "Arrival: ";
        }
        timesInfo +=
          this.$helpers.miltTimeConvert(time1.range[0]) +
          " - " +
          this.$helpers.miltTimeConvert(time1.range[1]);
      }

      if (this.tripVal > 0) {
        if (
          (time1.range[0] > 0 || time1.range[1] < 24) &&
          (time2.range[0] > 0 || time2.range[1] < 24)
        ) {
          timesInfo += " / ";
        }
        if (time2.range[0] > 0 || time2.range[1] < 24) {
          timesInfo += "RETURN - ";
          if (time2.segment === 0) {
            timesInfo += "Departure: ";
          } else {
            timesInfo += "Arrival: ";
          }
          timesInfo +=
            this.$helpers.miltTimeConvert(time2.range[0]) +
            " - " +
            this.$helpers.miltTimeConvert(time2.range[1]);
        }
      }

      return timesInfo;
    },
  },
  created() {
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
    this.ARRIVAL_TIME = 1;
    this.DEPARTURE_TIME = 0;
  },
};
</script>

<style lang="scss" scoped>
.dropdown + .dropdown {
  margin-left: 0 !important;
}
.field {
  min-width: 130px;
}
</style>
